import { render } from "./FluidChip.vue?vue&type=template&id=2bc4ceec"
const script = {}

import exportComponent from "/Users/tannerwelton/Development/zulu-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__